import { setTabPanel } from "../../../Store/slices/ui-slice";
import { store } from "../../../Store/store/store";

const { dispatch } = store;

export function handleTabClick(tab) {
  dispatch(setTabPanel(tab));
}
